import { useLoginModal } from "@/context/LoginModalContext";
import { usePassportProvider } from "@/context/PassportProvider";
import { LoadingModal } from "../core/LoadingModal";
import { GenericBonusModal } from "./GemBonusModal";
import { useBonus } from "./useGemBonus";

export const GemBonus = () => {
  const { bonusModalState, setBonusModalState, bonusDetails } = useBonus();

  const { openLoginModal } = useLoginModal();

  const { isLoggingIn } = usePassportProvider();

  return (
    <>
      {bonusModalState !== undefined ? (
        <GenericBonusModal
          bonusDetails={bonusDetails}
          state={bonusModalState}
          onLogin={openLoginModal}
          onClose={() => setBonusModalState(undefined)}
        />
      ) : null}
      <LoadingModal loading={isLoggingIn} text="Signing In..." />
    </>
  );
};
